import { render } from "./FileDropzone.vue?vue&type=template&id=cea02830"
import script from "./FileDropzone.vue?vue&type=script&lang=js"
export * from "./FileDropzone.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__